import { calculateLineAmount, formatMoney } from "../utils/invoiceMath";
import { Field } from "./FormControls";

const sanitizeNumber = (value) => {
  if (value === "") {
    return "";
  }

  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return "";
  }

  return parsed < 0 ? "0" : value;
};

export default function LineItemsEditor({
  items,
  currencySymbol,
  onAddItem,
  onRemoveItem,
  onUpdateItem,
}) {
  return (
    <section className="form-section line-items-editor">
      <div className="form-section-heading">
        <h2>Invoice line items</h2>
        <button className="button button-compact" type="button" onClick={onAddItem}>
          Add item
        </button>
      </div>

      <div className="line-item-list">
        {!items.length ? (
          <p className="empty-state">No invoice items added yet.</p>
        ) : null}

        {items.map((item, index) => {
          const amount = calculateLineAmount(item);

          return (
            <div className="line-item-card" key={item.id}>
              <div className="line-item-card-header">
                <strong>Item {index + 1}</strong>
                <button
                  className="button button-danger"
                  type="button"
                  onClick={() => onRemoveItem(item.id)}
                >
                  Remove
                </button>
              </div>

              <div className="line-item-grid">
                <label className="form-field form-field-wide" htmlFor={`${item.id}-description`}>
                  <span>Description *</span>
                  <input
                    id={`${item.id}-description`}
                    type="text"
                    value={item.description}
                    required
                    onChange={(event) =>
                      onUpdateItem(item.id, "description", event.target.value)
                    }
                  />
                </label>

                <Field
                  id={`${item.id}-rate`}
                  label="Rate"
                  type="number"
                  value={item.rate}
                  required
                  min="0"
                  step="0.01"
                  inputMode="decimal"
                  onChange={(value) => onUpdateItem(item.id, "rate", sanitizeNumber(value))}
                />

                <Field
                  id={`${item.id}-quantity`}
                  label="Quantity"
                  type="number"
                  value={item.quantity}
                  required
                  min="0"
                  step="0.01"
                  inputMode="decimal"
                  onChange={(value) =>
                    onUpdateItem(item.id, "quantity", sanitizeNumber(value))
                  }
                />

                <Field
                  id={`${item.id}-unit`}
                  label="Unit"
                  value={item.unit}
                  placeholder="KG"
                  onChange={(value) => onUpdateItem(item.id, "unit", value)}
                />

                <div className="amount-readout">
                  <span>Amount</span>
                  <strong>
                    {currencySymbol} {formatMoney(amount)}
                  </strong>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
